module.exports = __webpack_public_path__ + "img/unchecked.41f2802c.svg";